import createYearTabsListingView from '../PeriodTabs/createYearTabsListingView';
import FlexCompetitionCard from './FlexCompetitionCard';

export default createYearTabsListingView(FlexCompetitionCard, {
  displayName: 'CompetitionYearTabsView',
});
